import { ICourierInfo } from '../../../types';

/**
 * This function formats the inbound courier info response,
 * to add additional property `isNorthLadderCourier`  to the response.
 */
export function formatInboundCourierInfoResponse(
  raw: ICourierInfo
): ICourierInfo {
  const { courierProvider } = raw;

  /**
   * Check if the selected courier type is Northladder Staff
   */
  const isNorthLadderCourier: boolean = [
    'NL_STAFF',
    'NL_DEALER_TEAM',
    'NL_COURIER',
  ].includes(courierProvider || '');

  return { ...raw, isNorthLadderCourier };
}
